import type { Components, Theme } from '@mui/material';

import { colors } from '../tokens';

export const MuiRadio: Components<Theme>['MuiRadio'] = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      color: colors.gray[200],

      '&.Mui-checked': {
        color: colors.green[600],
      },

      '&.Mui-disabled:not(.Mui-checked)': {
        color: colors.gray[300],
      },

      '&.Mui-disabled.Mui-checked': {
        color: colors.green[600],
      },
    },
  },
};
